<template>
  <div class="cropper-content">
    <div
      class="cropper-box"
      :style="{ width: `100%`, height: `${boxHeight}px` }"
    >
      <vue-cropper
        v-loading="imgLoading"
        ref="cropper"
        :img="option.img"
        :outputSize="option.outputSize"
        :outputType="option.outputType"
        :info="option.info"
        :canScale="option.canScale"
        :autoCrop="option.autoCrop"
        :autoCropWidth="option.autoCropWidth"
        :autoCropHeight="option.autoCropHeight"
        :fixed="option.fixed"
        :fixedNumber="option.fixedNumber"
        :full="option.full"
        :fixedBox="option.fixedBox"
        :canMove="option.canMove"
        :canMoveBox="option.canMoveBox"
        :original="option.original"
        :centerBox="option.centerBox"
        :height="option.height"
        :infoTrue="option.infoTrue"
        :maxImgSize="option.maxImgSize"
        :enlarge="option.enlarge"
        :mode="option.mode"
        @realTime="realTime"
        @imgLoad="imgLoad"
        v-bind="options"
      ></vue-cropper>
    </div>
    <!--底部操作工具按钮-->
    <div class="footer-box">
      <div class="footer-info">
        <slot name="footerInfo"></slot>
      </div>
      <div class="footer-btn">
        <div class="scope-btn">
          <div class="" v-if="canUpload">
            <label class="btn" for="uploads">选择图片</label>
            <input
              type="file"
              id="uploads"
              :value="upload_input"
              style="position: absolute; clip: rect(0 0 0 0)"
              accept="image/png, image/jpeg, image/gif, image/jpg"
              @change="selectImg($event)"
            />
          </div>
          <el-button size="mini" type="danger" plain @click="rotateRight"
            >↻ 旋转</el-button
          >
          <el-button
            size="mini"
            type="danger"
            plain
            icon="el-icon-zoom-in"
            @click="changeScale(1)"
            >放大</el-button
          >
          <el-button
            size="mini"
            type="danger"
            plain
            icon="el-icon-zoom-out"
            @click="changeScale(-1)"
            >缩小</el-button
          >
        </div>
        <div class="upload-btn" v-if="canUpload">
          <el-button size="mini" type="success" @click="uploadImg('blob')">
            确认上传
            <i class="el-icon-upload"></i>
          </el-button>
          <el-button size="mini" type="danger" @click="delImg">删除</el-button>
        </div>
      </div>
    </div>
    <!--预览效果图-->
    <div class="show-preview">
      <div :style="previews.div" class="preview">
        <img :src="previews.url" :style="previews.img" />
      </div>
    </div>
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import axios from 'axios'

export default {
  name: 'CropperImage',
  components: {
    VueCropper,
  },
  props: {
    boxHeight: {
      type: [String, Number],
      default: 300,
    },
    uploadUrl: {
      type: String,
      default: '',
    },
    imgUrl: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    canUpload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgLoading: true,
      previews: {},
      upload_input: null,
      option: {
        img: this.imgUrl || '', // 裁剪图片的地址
        outputSize: 1, // 裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'jpeg', // 裁剪生成图片的格式（jpeg || png || webp）
        info: true, // 图片大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: false, // 是否默认生成截图框
        autoCropWidth: 130, // 默认生成截图框宽度
        autoCropHeight: 130, // 默认生成截图框高度
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [1.53, 1], // 截图框的宽高比例
        full: false, // false按原比例裁切图片，不失真
        fixedBox: true, // 固定截图框大小，不允许改变
        canMove: false, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        height: true, // 是否按照设备的dpr 输出等比例图片
        infoTrue: false, // true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000, // 限制图片最大宽度和高度
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: '100% 100%', // 图片默认渲染方式
      },
    }
  },
  watch: {
    imgUrl: {
      handler(val) {
        if (!val) {
          this.imgLoading = false
          this.$emit('loadComplete')
        } else {
          this.imgLoading = true
        }
        this.option.img = val || ''
      },
      immediate: true,
    },
  },
  methods: {
    // 关闭清空图片 src/components/LoopCropperImage/index.vue 有使用
    // eslint-disable-next-line vue/no-unused-properties
    clear() {
      this.option.img = ''
    },
    // 初始化函数
    imgLoad() {
      this.imgLoading = false
      this.$emit('loadComplete')
    },
    // 图片缩放
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },

    // 向右旋转
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },
    // 实时预览函数
    realTime(data) {
      this.previews = data
    },
    // 选择图片
    selectImg(e) {
      const file = e.target.files[0]
      console.log(file)
      if ((file.size / 1024 / 1024) > 2) {
        this.$message.error('请上传小于2MB的图片')
        return
      }
      if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
        this.$message({
          message: '图片类型要求：jpeg、jpg、png',
          type: 'error',
        })
        return false
      }
      // 转化为blob
      const reader = new FileReader()
      reader.onload = (ele) => {
        let data
        if (typeof ele.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([ele.target.result]))
        } else {
          data = ele.target.result
        }
        this.option.img = data
        this.upload_input = null
      }
      // 转化为base64
      reader.readAsDataURL(file)
    },
    // 上传图片
    uploadImg(type) {
      const _this = this
      if (type === 'blob') {
        // 获取截图的blob数据
        this.$refs.cropper.getCropBlob(async (data) => {
          const formData = new FormData()
          formData.append('file', data, 'DX.jpg')
          if ((data.size / 1024 / 1024) > 2) {
            this.$message.error('请上传小于2MB的图片')
            return
          }
          // 调用axios上传
          axios({
            url: this.uploadUrl,
            method: 'POST',
            data: formData,
            headers: {
              ...this.headers,
            },
          }).then((res) => {
            if (res.data.code === 1) {
              _this.$message({
                message: '上传成功',
                type: 'success',
              })
              _this.$emit('uploadImgSuccess', res.data.data)
            } else {
              _this.$message({
                message: '文件服务异常，请联系管理员！',
                type: 'error',
              })
            }
          })
        })
      }
    },
    delImg() {
      this.option.img = ''
      this.upload_input = null
      this.$emit('delImg')
    },

  },
}
</script>

<style scoped lang="scss">
.cropper-content {
  width: 100%;
  overflow: hidden;
  .cropper-box {
    position: relative;
    height: 300px;
  }
  .show-preview {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    justify-content: center;
    position: absolute;
    left: 200px;
    .preview {
      overflow: hidden;
      // border: 1px solid #67c23a;
      background: #ccc;
    }
  }
}

.footer-box {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  .footer-info {
    font-size: 20px;
    max-width: 280px;
  }
  .footer-btn {
    display: flex;
    min-width: 0;
    .scope-btn {
      display: flex;
      justify-content: space-between;
      margin-left: 10px;
      padding-right: 10px;
    }
    .upload-btn {
      flex: 1;
      -webkit-flex: 1;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      margin-top: 16px;
    }
    .btn {
      margin-right: 10px;
      outline: none;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      -webkit-appearance: none;
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      -webkit-transition: 0.1s;
      transition: 0.1s;
      font-weight: 500;
      padding: 8px 15px;
      font-size: 12px;
      border-radius: 3px;
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
    }
  }
}
</style>

